import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import config from "../../config";
import { HelmetProvider } from "react-helmet-async";
import BlogsSchema from "../../Components/BlogsSchema";

const BlogDetail = () => {
  const { seo_slug } = useParams();

  const [seoSlug, setSeoSlug] = useState(seo_slug);
  const [blogname, setBlogname] = useState("");
  const [blogid, setBlogid] = useState("");

  const [loading, setLoading] = useState(true);
  const [blog_detail, setBlog_detail] = useState([]);
  const [error, setError] = useState(null);

  // Contact form all field
  const [isSubmittingExam, setIsSubmittingExam] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [comment, setComment] = useState("");

  const [errors, setErrors] = useState({});

  // Meta Title, Description and Keyword Or Canonical URL
  const [meta_title, setMeta_title] = useState("");
  const [meta_description, setMeta_description] = useState("");

  //All Validations
  const validate = () => {
    const newErrors = {};

    if (!firstname && !lastname) {
      newErrors.first_last_name = "First and Last Name is required";
    } else if (!firstname) {
      newErrors.first_last_name = "First Name is required";
    } else if (!lastname) {
      newErrors.first_last_name = "Last Name is required";
    }

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }

    if (!phonenumber) {
      newErrors.phonenumber = "Phone Number is required";
    }

    if (!comment) {
      newErrors.comment = "Comment is required";
    }

    return newErrors;
  };

  useEffect(() => {
    document.title = `Blog Detail | Agile Seekers`;
    document.getElementById("bodywrap").className = "blogdetmain";

    // Define your API URL
    const apiUrl = `${config.API_BASE_URL}/blog_detail`;

    // Prepare the request payload
    const requestData = {
      seo_slug: seoSlug,
    };

    // Make the POST request
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status === 1) {
          setErrors({});

          setBlog_detail(response.data); // Set the fetched content
          setBlogid(response.data.id); // Set the fetched content
          setBlogname(response.data.name);
          setMeta_title(response.data.meta_title);
          setMeta_description(response.data.meta_description);
        } else {
          setError("Failed to load content");
          console.error("Error:", response.message);
        }
        setLoading(false); // Hide loading indicator
      })
      .catch((error) => {
        console.error("Fetch Error:", error);
      });
  }, [seoSlug]);

  // Meta Title
  // let metaTag = document.querySelector("meta[name='title']");
  // if (metaTag) {
  //   metaTag.setAttribute("content", meta_title); // Update meta title tag content
  // }
  document.title = `${meta_title} | Agile Seekers`;

  // Meta Description
  // let metaDescription = document.querySelector("meta[name='description']");
  // if (metaDescription) {
  //   metaDescription.setAttribute("content", meta_description); // Update meta description tag content
  // }

  // PMP exam form submit
  const PMPexam_submit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmittingExam(true);
      let item = {};
      item.blog_id = blogid;
      item.first_name = firstname;
      item.last_name = lastname;
      item.email = email;
      item.phone_number = phonenumber;
      item.comment = comment;
      item.blog_name = blogname;
      item.blog_url = window.location.href;

      try {
        let response = await fetch(`${config.API_BASE_URL}/pmp_exam`, {
          method: "post",
          body: JSON.stringify(item),
          headers: {
            "Content-Type": "application/json",
          },
        });
        response = await response.json();

        if (response.status === 1) {
          // Zoho Lead API Code Start
          const payload = {
            data: [
              {
                Company: "Agile",
                First_Name: firstname,
                Last_Name: lastname,
                Email: email,
                Phone: phonenumber,
                Lead_Status: "New",
                Lead_Source: "Blog",
                Page_URL: window.location.href,
              },
            ],
            trigger: ["approval", "workflow", "blueprint"],
          };

          try {
            const response = await fetch(
              `${config.API_BASE_URL}/zoho/blog_pmp_exam`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
              }
            );

            const result = await response.json();

            if (result.status === 1) {
              setErrors({});

              // toast.success(result.message);
            } else {
              // toast.error(result.message);
              console.error("Zoho Error:", result);
            }
          } catch (error) {
            console.error("Fetch error:", error);
          }
          // Zoho Lead API Code End

          setErrors({});
          setFirstname("");
          setLastname("");
          setEmail("");
          setPhonenumber("");
          setComment("");

          // Display alert with message
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An unexpected error occurred.");
      } finally {
        setIsSubmittingExam(false); // End the loading state
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const blog = {
    name: meta_title,
    description: meta_description,
    url: window.location.href,
  };

  return (
    <>
      <HelmetProvider>
        <BlogsSchema data={blog} />
      </HelmetProvider>

      <Navbar />

      <section className="bd-main">
        <Container>
          <Row>
            <Col md={8}>
              <Row className="bdl-top">
                <Col>
                  <h2>
                    {loading
                      ? "Loading..."
                      : error
                      ? `Error: ${error}`
                      : blog_detail.name}
                  </h2>
                  <div>
                    <div>
                      <h6>Blog Author</h6>
                      <h5>
                        {loading
                          ? "Loading..."
                          : error
                          ? `Error: ${error}`
                          : blog_detail.author}
                      </h5>
                    </div>
                    <div>
                      <h6>Published</h6>
                      <h5>
                        {loading
                          ? "Loading..."
                          : error
                          ? `Error: ${error}`
                          : blog_detail.published}
                      </h5>
                    </div>
                  </div>

                  {loading
                    ? "Loading..."
                    : error
                    ? `Error: ${error}`
                    : blog_detail && (
                        <>
                          <Image
                            src={blog_detail.image}
                            className="img-fluid"
                            alt="blog-fb"
                            title={blog_detail.image_title}
                          />
                        </>
                      )}
                </Col>
              </Row>
              <Row className="bdl-cont">
                <Col md={12}>
                  {loading
                    ? "Loading..."
                    : error
                    ? `Error: ${error}`
                    : blog_detail && (
                        <>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: blog_detail.description,
                            }}
                          />
                        </>
                      )}
                </Col>
              </Row>
            </Col>

            <Col md={4} className="bd-right">
              <div>
                <h3>Share This Article</h3>

                <div className="bd-social">
                  <Link to="/">
                    <Image
                      src={`${config.BASE_URL}/assets/images/blog-fb.png`}
                      className="img-fluid"
                      alt="blog-fb"
                    />
                  </Link>
                  <Link to="/">
                    <Image
                      src={`${config.BASE_URL}/assets/images/blog-twi.png`}
                      className="img-fluid"
                      alt="blog-twi"
                    />
                  </Link>
                  <Link to="/">
                    <Image
                      src={`${config.BASE_URL}/assets/images/blog-link.png`}
                      className="img-fluid"
                      alt="blog-link"
                    />
                  </Link>
                  <Link to="/">
                    <Image
                      src={`${config.BASE_URL}/assets/images/blog-whats.png`}
                      className="img-fluid"
                      alt="blog-whats"
                    />
                  </Link>
                </div>

                <div className="bd-form">
                  <h4>Have any Queries? Get in Touch</h4>

                  <Form>
                    <Row className="mb-2">
                      <Form.Group as={Col} controlId="fname">
                        <Form.Label className="d-none">First Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter First Name"
                          value={firstname}
                          onChange={(e) => setFirstname(e.target.value)}
                        />
                      </Form.Group>

                      <Form.Group as={Col} controlId="lname">
                        <Form.Label className="d-none">Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Last Name"
                          value={lastname}
                          onChange={(e) => setLastname(e.target.value)}
                        />
                      </Form.Group>

                      {/* First and Last Name validation */}
                      {errors.first_last_name && (
                        <div className="text-danger">
                          {errors.first_last_name}
                        </div>
                      )}
                    </Row>

                    <Form.Group className="mb-2" controlId="email">
                      <Form.Label className="d-none">Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />

                      {/* Email validation */}
                      {errors.email && (
                        <div className="text-danger">{errors.email}</div>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-2" controlId="phone">
                      <Form.Label className="d-none">Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Phone Number"
                        value={phonenumber}
                        onChange={(e) => setPhonenumber(e.target.value)}
                      />
                      {/* Phone number validation */}
                      {errors.phonenumber && (
                        <div className="text-danger">{errors.phonenumber}</div>
                      )}
                    </Form.Group>

                    <Row className="mb-3">
                      <Form.Group className="mb-2" controlId="message">
                        <Form.Label className="d-none">comment</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          placeholder="Enter Comment"
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                        />

                        {/* comment validation */}
                        {errors.comment && (
                          <div className="text-danger">{errors.comment}</div>
                        )}
                      </Form.Group>
                    </Row>

                    <Button
                      variant="primary"
                      type="button"
                      onClick={PMPexam_submit}
                      disabled={isSubmittingExam}
                    >
                      {isSubmittingExam ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="mx-2"
                          />
                          Loading...
                        </>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default BlogDetail;
